import { colorSystem, Flexbox, FontVariant, Text, Tooltip } from '@luminovo/design-system';
import { formatLongDateTime, formatRelativeTime } from '@luminovo/frontend-utils';

export function TimeStamp({
    title,
    time,
    variant = 'h5',
}: {
    title: string;
    time: string;
    variant?: FontVariant;
}): JSX.Element {
    return (
        <Flexbox gap={4}>
            <Text variant={variant} style={{ color: colorSystem.neutral[5] }}>
                {title}
            </Text>
            <Tooltip title={formatLongDateTime(time)}>
                <Text variant={variant} color={colorSystem.neutral[8]}>
                    {formatRelativeTime(time)}
                </Text>
            </Tooltip>
        </Flexbox>
    );
}
